<div class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main" [ngClass]="{
        'fdx-c-modal__main--small': modalDialogType==='SMALL',
        'fdx-c-modal__main--medium':modalDialogType==='MEDIUM',
        'fdx-c-modal__main--large':(modalDialogType==='LARGE'),
        'fdx-c-modal__main--full-height': modalDialogType==='FULL_HEIGHT',        
        'fdx-c-modal__main--': modalDialogType==='DEFAULT'
      }">
        <div class="fdx-c-modal__body">
            <!--<h3 class="fdx-c-modal__title">SUCCESS</h3>-->
            <div class="fdx-c-notification__header">
                <div class="icon-row">
                    <svg class="fdx-c-icon" aria-hidden="true">
                        <use xlink:href="#exclamation-triangle"></use>
                    </svg>
                    <span class="error-handle" *ngIf="errorTrace" (click)="copyUUID()">
                         <span class="error-text error-trace__status" *ngIf="errorTrace.uuid">
                            <span *ngIf="isUUIDCopied" class="uuid-title"> {{"APP.AppButton_UUID" | translate: {Default: "UUID"} }} : </span>
                             <span *ngIf="!isUUIDCopied">{{"APP.AppButton_Copyuuidforitsupport" | translate: {Default: "Copy UUID for IT support"} }} </span>
                             <span *ngIf="isUUIDCopied">{{ errorTrace.uuid || ''}}</span>
                            <svg class="copy-icon fdx-c-icon ml-1 mr-2 fdx-u-font-size--h4"
                                        aria-hidden="true" focusable="false" role="presentation"><use xlink:href="#copy_icon"></use></svg>
                        </span>

                    </span>
                    <span class="error-copy-status error-trace__status" [ngClass]="{'error-copy-status--visible': copyStatus}">{{ copyStatus }}</span>

                </div>
                

            </div>
            <div class="fdx-c-modal__description" translate>
                 <br>   
                {{modalDialogBodyContent}}
            </div> 
             <div class="fdx-c-modal__footer" translate>
                 <br> 
                 <div class="modal_footer_area">
                        <span class="closing_timer d-flex" *ngIf="isTimerEnabled">
                            <span class="closing_timer_text">{{"APP.AppMessage_Closingin" | translate: {Default: "Closing in"} }} {{ remainingSeconds }} {{"APP.AppMessage_Seconds" | translate: {Default: "seconds"} }}</span>
                            <button 
                            type="button" 
                            class="modal_cancel_button fdx-c-button fdx-c-button--text"
                            (click)="cancelAutoClose()">
                                <span>{{"APP.AppButton_Pause" | translate: {Default: "Pause"} }}</span>
                            </button>
                    </span> 
               
                     <button (click)="onClose('close')" class="modal_close_button fdx-c-button fdx-c-button--primary">{{modalButtonVal}}</button>
                 </div> 
                 
            </div>            
        </div>
    </div>
</div>